<template>
  <div class="service-unit-setting">
    <PageTitleExtra
      :title="$t('serviceUnitSetting.title')"
      :tooltip="$t('serviceUnitSetting.tooltip')"
      cyBtn1="new-unit-btn"
      :btn="$t('common.button.create.text')"
      @btnClick="openDialog('create')"
    />

    <FiltersContainer>
      <BaseElInput
        v-model="nameSearch"
        testName="search_name"
        clearable
        :placeholder="$t('serviceUnitSetting.search.name.placeholder')"
        @keypress.enter.native="refresh(true)"
        @clear="refresh(true)"
      >
        <i slot="suffix" class="el-input__icon el-icon-search" @click="refresh(true)" />
      </BaseElInput>
    </FiltersContainer>

    <section>
      <p>{{ $t('serviceUnitSetting.totalUnitCount.title', { totalUnitCount: totalUnitCount }) }} / {{ $t('serviceUnitSetting.contractUnitCount.title', { contractUnitCount: contractUnitCount }) }}</p>
      <ProgressBar :percentage="unitCountPercentage" />
      <!-- <el-progress :text-inside="true" :stroke-width="20" :percentage="unitCountPercentage" :color="colorList"></el-progress> -->
    </section>

    <section>
      <BaseTable v-loading="loading" :data="serviceUnitList" :empty-text="$t('common.table.empty.text')" testName="預約服務人員">
        <EmptyBlock slot="empty" />
        <BaseElTableColumn prop="name" :label="$t('serviceUnitSetting.table.image.title')" align="center" width="150">
          <template slot-scope="scope">
            <img style="margin: auto;" width="90" :src="imgSource(scope.row.Image)" alt="">
          </template>
        </BaseElTableColumn>
        <BaseElTableColumn prop="name" :label="$t('serviceUnitSetting.table.name.title')" align="center" />
        <BaseElTableColumn prop="color" :label="$t('serviceUnitSetting.table.color.title')" align="center">
          <template slot-scope="scope">
            <div
              v-if="scope.row.color"
              :style="
                `
            background: ${scope.row.color};
            width: 50%;
            height: 20px;
            margin: auto;
            `
              "
            />
          </template>
        </BaseElTableColumn>
        <!-- <BaseElTableColumn prop="description" label="敘述" align="center" show-overflow-tooltip="" /> -->
        <BaseElTableColumn prop="bookingMax" :label="$t('serviceUnitSetting.table.bookingMax.title')" width="150" align="center" />
        <BaseElTableColumn v-if="!isOverseasShop" :label="$t('serviceUnitSetting.table.isPublic.title')" width="150" align="center">
          <template slot-scope="scope">
            <Tag :type="tagType(scope.row.isPublic)">{{ (scope.row.isPublic)? $t('common.yes.text') : $t('common.no.text') }}</Tag>
          </template>
        </BaseElTableColumn>
        <BaseElTableColumn v-if="usePubApt" prop="isPubApt" :label="$t('serviceSetting.table.isPubApt.title')" width="120" align="center">
          <template slot-scope="scope">
            <Tag :type="tagType(scope.row.isPubApt)">{{ (scope.row.isPubApt)? $t('common.yes.text') : $t('common.no.text') }}</Tag>
          </template>
        </BaseElTableColumn>
        <BaseElTableColumn :label="$t('serviceUnitSetting.table.googleCalendar.title')" width="150" align="center">
          <template slot-scope="scope">
            <BaseElButton type="text" class="text-btn" @click="openBindDialog(scope.row)">{{ $t('serviceUnitSetting.button.binding.text') }}</BaseElButton>
          </template>
        </BaseElTableColumn>
        <BaseElTableColumn prop="name" :label="$t('common.table.action.text')" fixed="right" width="110" align="center">
          <template slot-scope="scope">
            <TableEditBtnGroup
              :testName="scope.row?.name"
              @edit="openDialog('update'), syncFormData(scope.row), selectRow=scope.row, findServiceUnit()"
              @delete="deleteDialog=true, selectRow=scope.row"
            />
          </template>
        </BaseElTableColumn>
      </BaseTable>

      <Pagination
        :curPage.sync="tableOptions.page"
        :pageLimit="tableOptions.pageLimit"
        :total="serviceUnitCount"
        @pageChange="refresh(false)"
      />
    </section>

    <image-cropper v-if="uploadDialog" :image="formData.img" @uploaded="getImage" @close="uploadDialog = false" />

    <!-- 新增服務人員 Dialog -->
    <el-dialog :title="dialogTitle" :visible.sync="showDialog" :close-on-click-modal="false" @close="resetForm()">
      <BaseElForm ref="form" :model="formData" label-position="top" :rules="formRules">
        <BaseElFormItem :label="$t('serviceUnitSetting.table.image.title')">
          <template slot="label">
            <FormItemTooltipLabel
              :label="$t('serviceUnitSetting.table.image.title')"
              class="title"
            >
              {{ $t('serviceUnitSetting.dialog.image.tooltip') }}
            </FormItemTooltipLabel>
          </template>
          <UploadButton
            cyUploadBtn="service-unit-img-upload"
            cyUploadedImg="service-unit-img-uploaded"
            :img="formData.avatar"
            :isAvatar="true"
            @change="loadImg"
          />
        </BaseElFormItem>
        <BaseElFormItem :label="$t('serviceUnitSetting.dialog.name.title')" prop="name">
          <BaseElInput
            v-model="formData.name"
            :maxlength="55"
            show-word-limit
            testName="formData_name"
            :placeholder="$t('serviceUnitSetting.dialog.name.placeholder')"
          />
        </BaseElFormItem>
        <BaseElFormItem :label="$t('serviceUnitSetting.dialog.order.title')" prop="order">
          <template slot="label">
            <FormItemTooltipLabel
              :label="$t('serviceUnitSetting.dialog.order.title')"
              class="title"
            >
              {{ $t('serviceUnitSetting.dialog.order.tooltip') }}
            </FormItemTooltipLabel>
          </template>
          <BaseElInput
            v-model="formData.order"
            testName="formData_order"
            :placeholder="$t('serviceUnitSetting.dialog.order.placeholder')"
          />
        </BaseElFormItem>
        <BaseElFormItem :label="$t('serviceUnitSetting.dialog.color.title')" prop="color">
          <template slot="label">
            <FormItemTooltipLabel
              :label="$t('serviceUnitSetting.dialog.color.title')"
              class="title"
            >
              {{ $t('serviceUnitSetting.dialog.color.tooltip') }}
            </FormItemTooltipLabel>
          </template>
          <BaseElSelect
            v-model="formData.color"
            testName="formData_color"
            :placeholder="$t('serviceUnitSetting.dialog.color.placeholder')"
            :no-data-text="$t('common.select.empty.text')"
            class="color"
          >
            <BaseElSelectOption
              v-for="item in colorList"
              :key="item.name"
              :label="item.name"
              :value="item.name"
            >
              <div
                :style="
                  `margin:5px 0; background: ${item.code}; color: white; width:100%; height: 28px; border-radius:4px;`
                "
              />
            </BaseElSelectOption>
          </BaseElSelect>
        </BaseElFormItem>
        <BaseElFormItem v-if="!isOverseasShop" :label="$t('serviceUnitSetting.dialog.isPublic.title')" prop="public">
          <BaseElSwitch
            v-model="formData.isPublic"
            testName="formData_isPublic"
            :active-text="$t('common.yes.text')"
            :inactive-text="$t('common.no.text')"
          />
        </BaseElFormItem>

        <BaseElFormItem v-if="usePubApt" :label="$t('createReservationService.isPubApt.title')">
          <BaseElSwitch
            v-model="formData.isPubApt"
            testName="formData_isPubApt"
            :active-text="$t('common.yes.text')"
            :inactive-text="$t('common.no.text')"
          />
        </BaseElFormItem>
        <BaseElFormItem :label="$t('serviceUnitSetting.dialog.bookingMax.title')" prop="bookingMax">
          <template slot="label">
            <FormItemTooltipLabel
              :label="$t('serviceUnitSetting.dialog.bookingMax.title')"
              class="title"
            >
              {{ $t('serviceUnitSetting.dialog.bookingMax.tooltip') }}
            </FormItemTooltipLabel>
          </template>
          <BaseElInput
            v-model="formData.bookingMax"
            testName="formData_bookingMax"
          />
        </BaseElFormItem>
        <BaseElFormItem :label="$t('serviceUnitSetting.dialog.services.title')" prop="appointmentServices">
          <template slot="label">
            <FormItemTooltipLabel
              :label="$t('serviceUnitSetting.dialog.services.title')"
              class="title"
            >
              {{ $t('serviceUnitSetting.dialog.services.tooltip') }}
            </FormItemTooltipLabel>
          </template>
          <UnitServicesSelect
            testName="formData_services"
            :model.sync="formData.services"
            multiple
            :showAll="true"
            :option-filter="bindingServicesFilter"
          />
          <!-- <ServiceSearch class="w-full" :model.sync="formData.services" multiple/> -->
        </BaseElFormItem>
        <BaseElFormItem :label="$t('serviceUnitSetting.dialog.users.title')" prop="appointmentServices">
          <template slot="label">
            <FormItemTooltipLabel
              :label="$t('serviceUnitSetting.dialog.users.title')"
              class="title"
            >
              {{ $t('serviceUnitSetting.dialog.users.tooltip') }}
            </FormItemTooltipLabel>
          </template>
          <!-- <UserSearch class="w-full" :model.sync="formData.users" role="shopProvider" multiple/> -->
          <BaseElSelect
            v-model="formData.users"
            testName="formData_users"
            value-key="id"
            multiple
            collapse-tags
            :placeholder="$t('serviceUnitSetting.dialog.users.placeholder')"
            :no-data-text="$t('common.table.empty.text')"
          >
            <BaseElSelectOption
              v-for="item in allowBindUserList"
              :key="item.id"
              :label="`${item.name} (${item.id.slice(-5)})`"
              :value="item"
            />
          </BaseElSelect>
        </BaseElFormItem>
      </BaseElForm>

      <div slot="footer">
        <BaseElButton testName="edit-dialog_cancel-btn" plain @click="showDialog = false, resetForm()">{{ $t('common.button.return.text') }}</BaseElButton>
        <BaseElButton testName="edit-dialog_confirm-btn" type="primary" @click="dialogConfirm">{{ $t('common.button.save.text') }}</BaseElButton>
      </div>
    </el-dialog>

    <el-dialog v-if="selectRow" :close-on-click-modal="false" :title="`${$t('serviceUnitSetting.dialog.googleCalendar.title')} - ${selectRow.name}`" :visible.sync="bindDialog" @close="resetForm()">
      <BaseElForm ref="form" :model="formData" :rules="formRules" label-position="top">
        <BaseElFormItem :label="$t('serviceUnitSetting.dialog.gmailAccount.title')" prop="gmail">
          <div class="flex-between">
            <BaseElInput v-model="formData.gmail" v-loading="gLoading" :placeholder="$t('common.input.placeholder')" :disabled="gLoading" />
            <BaseElButton type="text" class="text-btn" @click="bindCalendar">{{ $t('serviceUnitSetting.dialog.link.text') }}</BaseElButton>
          </div>
        </BaseElFormItem>
      </BaseElForm>

      <div class="dashed-line">
        <svg viewBox="0 0 500 10">
          <line
            x1="0"
            y1="5"
            x2="500"
            y2="5"
            stroke="black"
            stroke-dasharray="7 5"
          />
        </svg>
      </div>

      <div class="flex-col mb-2">
        <span style="color: #2D271B; font-weight: 500;">{{ $t('serviceUnitSetting.dialog.boundAccount.title') }}</span>
        <span style="color: #2BB8C1; font-weight: 400;">{{ $t('serviceUnitSetting.dialog.boundAccount.warning.text') }}</span>
      </div>

      <BaseElForm label-position="top">
        <BaseElFormItem v-for="account in gCalendarList" :key="account.id" v-loading="gLoading" :label="$t('serviceUnitSetting.dialog.gmailAccount.title')">
          <div class="flex-between">
            <span style="font-weight: 400;">{{ account.scope.value }}</span>
            <BaseElButton
              type="text"
              class="cancel-text-btn"
              testName="remove-google-calendar"
              @click="deleteGoogleCalendar(account.scope.value)"
            >
              {{ $t('common.button.delete2.text') }}
            </BaseElButton>
          </div>
        </BaseElFormItem>
      </BaseElForm>

      <div slot="footer">
        <BaseElButton plain @click="bindDialog = false, resetForm()">{{ $t('common.button.return.text') }}</BaseElButton>
      </div>
    </el-dialog>

    <DeleteDialog
      v-if="deleteDialog"
      :title="$t('common.dialog.delete.title')"
      data-testid="service-setting_delete-dialog"
      :content="$t('common.dialog.delete.content')"
      width="40%"
      @close="deleteDialog = false"
      @delete="deleteServiceUnit(), deleteDialog=false"
    />
  </div>
</template>

<script>
import { computed } from 'vue'
import { mapGetters } from 'vuex'
import ProgressBar from '@/components/Progress/ProgressBar'
import UnitServicesSelect from '@/components/Select/UnitServicesSelect.vue'
import EmptyBlock from '@/components/EmptyBlock.vue'
import DeleteDialog from '@/components/Dialog/DeleteDialog'
import { noEmptyRules, isDigitRules, rangeRules, emailRules } from '@/validation'
import {
  CreateServiceUnit,
  GetServiceUnit,
  GetServiceUnitCount,
  DeleteServiceUnit,
  UpdateServiceUnit,
  FindServiceUnit,
  GetGoogleCalendar,
  CreateGoogleCalendar,
  DeleteGoogleCalendar,
  GetAllowBindUserList,
} from '@/api/serviceUnit'
import UploadButton from '@/components/Button/UploadButton.vue'
import ImageCropper from '@/components/ImageCropper.vue'
import FormItemTooltipLabel from '@/components/Form/FormItemTooltipLabel.vue'
// Utils
import { pageStartIndex } from '@/utils/table'
import formUtils from '@/utils/form'
import { dialogTitle } from '@/utils/dialog'
import { extractList, imgSrc } from '@/utils/helper'
import { shiftColors } from '@/config/reservation'
import { find, get } from 'lodash'
import { i18n } from '@/plugins/i18n/i18n'
// // import * as cssvars from '@/styles/ohbot/_variables.scss'
import { usePermissions } from '@/use/permissions'
import store from '@/store'

export default {
  name: 'ServiceUnitSetting',
  components: { ProgressBar, UploadButton, ImageCropper, DeleteDialog, EmptyBlock, UnitServicesSelect, FormItemTooltipLabel },
  setup () {
    const { checkAction } = usePermissions()
    const bindingServicesFilter = (service) => {
      if (!service.enableAppointmentUnit) return false
      return true
    }
    const usePubApt = computed(() => checkAction('admin.pubAptConfig.page'))
    const isOverseasShop = computed(() => get(store.state, 'org.isOverseasShop'))
    return {
      bindingServicesFilter,
      usePubApt,
      isOverseasShop,
    }
  },
  data: () => ({
    nameSearch: '',
    loading: false,
    gLoading: false,
    showDialog: false,
    deleteDialog: false,
    uploadDialog: false,
    bindDialog: false,
    dialogType: '',

    selectRow: null,
    selectUnit: null,

    avatarChanged: false,
    // imgSize: 90,
    imgSize: 90,

    colorList: shiftColors,

    tableOptions: {
      page: 1,
      pageLimit: 10,
    },

    totalUnitCount: 0,
    allowBindUserList: [],
    serviceUnitList: [],
    serviceUnitCount: 0,

    gCalendarList: [],

    // Form
    formData: {
      gmail: '',
      img: null,
      avatar: null,
      name: '',
      description: '',
      isPublic: true,
      isPubApt: false,
      bookingMax: '',
      services: [],
      users: [],
      order: 100,
      color: null,
    },

    formRules: {
      gmail: emailRules(),
      name: noEmptyRules(i18n.t('validation.noEmptyRules.name.text')),
      // description: noEmptyRules('請輸入服務人員敘述'),
      bookingMax: [isDigitRules(), noEmptyRules(i18n.t('validation.noEmptyRules.bookingMax.text')), rangeRules()],
      order: [isDigitRules(), noEmptyRules(i18n.t('validation.noEmptyRules.order.text'))],
      color: [noEmptyRules()],
    },

  }),
  computed: {
    ...mapGetters([
      'shop',
      'userPlanLimit',
    ]),

    contractUnitCount () {
      return this.userPlanLimit.appointmentUnitLimit
    },

    unitCountPercentage () {
      if (this.userPlanLimit.appointmentUnitLimit === 0) {
        return 0
      }

      const count = Math.round(this.totalUnitCount * 100 / this.userPlanLimit.appointmentUnitLimit)
      return count > 100 ? 100 : count
    },

    pageStartIndex () {
      return pageStartIndex(this.tableOptions.page, this.tableOptions.pageLimit)
    },

    user () {
      return this.$store.state.user
    },

    userList () {
      return extractList('id', this.formData.users)
    },

    servicesList () {
      return extractList('id', this.formData.services)
    },

    dialogTitle () {
      return dialogTitle(
        this.dialogType,
        {
          create: i18n.t('serviceUnitSetting.dialog.create.title'),
          update: i18n.t('serviceUnitSetting.dialog.edit.title'),
        },
      )
    },
  },

  async mounted () {
    await this.refresh()
  },

  methods: {
    tagType (val) {
      let type = 'info'
      if (val) type = 'action'
      // if(! val) type = 'danger'
      return type
    },
    imgSource (image) {
      return imgSrc(this.imgSize, image)
    },

    getImage (data) {
      this.formData.avatar = data
      this.avatarChanged = true
      this.uploadDialog = false
    },
    loadImg (img) {
      this.formData.img = img
      this.uploadDialog = true
    },

    syncFormData (row) {
      this.formData.name = row.name
      this.formData.order = row.order
      this.formData.avatar = row.Image
      this.formData.description = row.description
      this.formData.isPublic = row.isPublic
      this.formData.isPubApt = row.isPubApt
      const color = find(this.colorList, { code: row.color })
      this.formData.color = get(color, 'name')
      this.formData.bookingMax = row.bookingMax.toString()
    },

    async getAllowBindUserList () {
      const [res, err] = await GetAllowBindUserList({
        shopId: this.shop,
      })
      if (err) {
        this.$message.error(err)
        return
      }
      this.allowBindUserList = res
    },

    async refresh (search = false) {
      if (search) this.tableOptions.page = 1
      this.loading = true
      await Promise.allSettled([
        this.getAllowBindUserList(),
        this.getServiceUnit(),
        this.getServiceUnitCount(),
        this.getTotalUnitCount(),
      ])
      // await this.getServiceUnit()
      // await this.getServiceUnitCount()
      // await this.getTotalUnitCount()
      this.loading = false
    },

    async dialogConfirm () {
      if (!await this.checkForm()) return
      const type = this.dialogType
      if (type === 'create') this.createServiceUnit()
      if (type === 'update') this.updateServiceUnit()
      this.showDialog = false
    },

    //= > 檢查表單輸入驗證
    async checkForm () {
      return await formUtils.checkForm(this.$refs.form)
    },

    //= > 重置表單
    resetForm () {
      formUtils.resetForm(this.$refs.form)
      this.formData = {
        img: null,
        avatar: null,
        name: '',
        description: '',
        isPublic: true,
        isPubApt: false,
        bookingMax: '',
        services: [],
        users: [],
        order: 100,
        color: null,
      }
    },

    async openBindDialog (row) {
      this.bindDialog = true
      this.selectRow = row
      await this.getGoogleCalendar()
    },

    async bindCalendar () {
      try {
        if (!await this.checkForm()) return
        this.gLoading = true
        await CreateGoogleCalendar({
          shopId: this.shop,
          id: this.selectRow.id,
          email: this.formData.gmail,
        })
        this.formData.gmail = ''
        await this.getGoogleCalendar()
        this.$message.success(i18n.t('common.message.bindSuccess'))
      } catch (error) {
        console.log(error)
        this.$message.error(error || error.message)
      } finally {
        this.gLoading = false
      }
    },

    async getGoogleCalendar () {
      try {
        this.gLoading = true
        const res = await GetGoogleCalendar({
          shopId: this.shop,
          id: this.selectRow.id,
        })
        this.gCalendarList = res
      } catch (error) {
        console.log(error)
        this.$message.error(error || error.message)
      } finally {
        this.gLoading = false
      }
    },

    async deleteGoogleCalendar (email) {
      try {
        await DeleteGoogleCalendar({
          shopId: this.shop,
          id: this.selectRow.id,
          email,
        })
        await this.getGoogleCalendar()
      } catch (error) {
        console.log(error)
        this.$message.error(error || error.message)
      }
    },

    //= > 創建服務人員
    async createServiceUnit () {
      if (!this.shop) this.$message.error(i18n.t('serviceCategorySetting.message.selectStoreFirst.text'))
      try {
        await CreateServiceUnit({
          shopId: this.shop,
          name: this.formData.name,
          image: (!this.formData.avatar) ? undefined : this.formData.avatar.id,
          // description: this.formData.description,
          bookingMax: this.formData.bookingMax,
          isPublic: this.formData.isPublic,
          isPubApt: this.formData.isPubApt,
          appointmentServices: this.servicesList,
          users: this.userList,
          order: this.formData.order,
          color: find(this.colorList, { name: this.formData.color }).code,
        })
        await this.refresh()
        this.$message.success(i18n.t('common.message.createSuccess2'))
      } catch (error) {
        console.log(error)
        this.$message.warning(error)
      }
    },

    //= > 刪除服務人員
    async deleteServiceUnit () {
      try {
        await DeleteServiceUnit({
          shopId: this.selectRow.ShopId,
          id: this.selectRow.id,
        })

        await this.refresh()
        this.$message.success(i18n.t('common.message.deleteSuccess'))
      } catch (error) {
        console.log(error)
        this.$message.warning(error)
      }
    },

    //= > 更新服務人員
    async updateServiceUnit () {
      const colorName = get(this.formData, 'color')
      const color = find(this.colorList, { name: colorName })
      try {
        await UpdateServiceUnit({
          shopId: this.selectRow.ShopId,
          id: this.selectRow.id,
          name: this.formData.name,
          image: (this.avatarChanged) ? this.formData.avatar.id : undefined,
          // description: this.formData.description,
          bookingMax: this.formData.bookingMax,
          isPublic: this.formData.isPublic,
          isPubApt: this.formData.isPubApt,
          appointmentServices: this.servicesList,
          users: this.userList,
          order: this.formData.order,
          color: get(color, 'code'),
        })

        await this.refresh()
        this.$message.success(i18n.t('common.message.updateSuccess'))
      } catch (error) {
        console.log(error)
        this.$message.warning(error)
      }
    },

    //= > 取得服務人員
    async getServiceUnit () {
      this.loading = true
      try {
        const startIndex = this.pageStartIndex
        const limit = this.tableOptions.pageLimit
        const res = await GetServiceUnit({
          shopId: this.shop,
          start: startIndex,
          limit,
          name: (this.nameSearch === '') ? undefined : this.nameSearch,
        })
        this.serviceUnitList = res
        this.loading = false
      } catch (error) {
        console.log(error)
        this.$message.warning(error)
      }
    },

    //= > 取得服務人員總數(無過濾)
    async getTotalUnitCount () {
      try {
        const res = await GetServiceUnitCount({
          shopId: this.shop,
        })
        this.totalUnitCount = res
      } catch (error) {
        console.log(error)
        this.$message.warning(error)
      }
    },

    //= > 取得服務人員總數
    async getServiceUnitCount () {
      try {
        const res = await GetServiceUnitCount({
          shopId: this.shop,
          name: (this.nameSearch === '') ? undefined : this.nameSearch,
        })
        this.serviceUnitCount = res
      } catch (error) {
        console.log(error)
        this.$message.warning(error)
      }
    },

    //= > 取得指定服務人員
    async findServiceUnit () {
      try {
        const res = await FindServiceUnit({
          shopId: this.shop,
          id: this.selectRow.id,
        })
        this.selectUnit = res
        this.formData.services = res.AppointmentServices.filter(item => !item.isRemove)
        this.formData.users = res.Users
      } catch (error) {
        this.$message.warning(error)
      }
    },

    openDialog (type) {
      this.dialogType = type
      this.showDialog = true
    },
  },

}
</script>

<style lang="scss" scoped>
.text-btn {
  @apply text-normal text-primary-100;
}
.cancel-text-btn {
  font-size: 16px;
}
line {
  stroke: #5E5E5E;
}
.dashed-line {
  height: 13px;
  stroke-width: 0.5;
  margin-bottom: 20px;
}
</style>
